/*
Author: Bhushan
Date: 06/07//2022
Issue Description: Configure FBP to client .
*/

<template>
  <div class="main-container">
    <tl-header type="h1">
      <div>FBP Settings</div>
      <template slot="icon">
        <div class="showIntro">
          <img src="@/assets/questionmark.png" />
        </div>
      </template>
    </tl-header>
    <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
      You have only view permission.
    </div>
    <div class="itDeclarations">
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => (toast = val)"
      />
      <tl-accordion headerName="FBP Declaration" :active="true">
        <template v-slot:accordionBody>
          <div :disabled="!(ifEnableFBP && ifTeamleaderPermission) || ifSuperAdmin">
            <div class="row">
              <div class="col-12 margin-b-s">
                <span class="label">Date range for FBP declaration</span>
              </div>
              <!-- <div class="col-3">
                <tl-select
                  label="Start Month *"
                  name="Start Month"
                  :options="['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']"
                  v-model="incomeTaxModel.declarationSettings.declarationStartMonth"
                  @change="(val) => incomeTaxModel.declarationSettings.declarationStartMonth = val"
                  data-vv-as="start month"
                  v-validate="{required: true}"
                  :classname="errors.has('Start Month')"
                  :errormsg="errors.first('Start Month')"
                />
              </div> -->
              <div class="col-3">
                <tl-select
                  label="From *"
                  name="From"
                  :options="Array.from(Array(31).keys(), (val) => val + 1)"
                  v-model="
                    formdata.declaration_start_date
                  "
                  @change="(val)=>{getDeclarationDayList(formdata.declaration_start_date = val, formdata.declaration_end_date); formdata.declaration_end_date=null}"
                />
              </div>
              <div class="col-3">
                <tl-select
                  label="To *"
                  name="To"
                  :options="Array.from(Array(31-Number(formdata.declaration_start_date)).keys(), val=>Number(formdata.declaration_start_date)+val+1)"
                  v-model="formdata.declaration_end_date"
                  @change="(val)=>{getDeclarationDayList(formdata.declaration_start_date, formdata.declaration_end_date = val)}"
                />
              </div>
            </div>
            <div class="row margin-t-l">
              <div class="col-12">
                <span class="label">Reminder Settings</span>
              </div>
              <div class="col-12 margin-t-m">
                <tl-radio
                  label="Periodically"
                  name="reminderSettings"
                  v-model="
                    formdata.declaration_reminder_option
                  "
                  value="everyday"
                  id="periodically"
                  data-vv-as="IT Declaration Reminder Settings"
                  ref="reminderSettingsVal"
                />
              </div>
              <div class="col-12 margin-t-15px">
                <tl-radio
                  label="On Specific Dates"
                  name="reminderSettings"
                  v-model="
                    formdata.declaration_reminder_option
                  "
                  @change="(val) => formdata.declaration_reminder_option = val"
                  value="selected_days"
                  id="specific"
                  data-vv-as="IT Declaration Reminder Settings"
                  ref="reminderSettingsVal"
                />
              </div>
              <div
                class="col-12 margin-t-m"
                v-if="
                  formdata.declaration_reminder_option == 'selected_days'
                "
              >
                <ul class="days-box">
                  <li
                    :class="{ selected: day.selected }"
                    v-for="(day, index) in monthDays"
                    :key="index"
                    :value="day.day"
                    @click="weekOffDays(index)"
                  >
                    {{ day.day }}
                  </li>
                </ul>
              </div>
              <div
                class="col-12 margin-t-m"
                v-if="
                  formdata.declaration_reminder_option != 'selected_days'
                "
              >
                <tl-select
                  label="Start Date *"
                  name="declarationReminderStartDate"
                  labelText="day"
                  v-model="formdata.declaration_reminder_date"
                  :options="monthDays"
                  @change="
                    (val) =>
                      (formdata.declaration_reminder_date = val.day)"
                />
              </div>
            </div>
            <div class="row margin-t-m">
              <div class="col-12">
                <tl-select
                  label="Send Reminder To *"
                  labelText="name"
                  name="Send Reminder"
                  v-model="formdata.declaration_reminder_data"
                  :options="reminderToOptions"
                  @change="
                    (val) =>
                      (formdata.declaration_reminder_data =
                        val)
                  "
                  data-vv-as="send reminder to"
                />
              </div>
              <div class="col-12">
                <div class="row margin-t-m">
                  <div class="margin-t-m">
                    <span>Send Reminder On : </span>
                  </div>
                  <tl-select
                    class="select"
                    labelText="name"
                    name="hr:"
                    :options="hourOption"
                    v-model="formdata.declaration_send_on_hr"
                    @change="
                      (val) =>
                        (formdata.declaration_send_on_hr = val)
                    "
                  />
                  <div class="margin-t-m">
                    <span> Hours</span>
                  </div>
                  <tl-select
                    class="select"
                    labelText="name"
                    name="min:"
                    :options="minutesOption"
                    v-model="formdata.declaration_send_on_min"
                    @change="
                      (val) =>
                        (formdata.declaration_send_on_min = val)
                    "
                  />
                  <div class="margin-t-m">
                    <span>Minutes</span>
                  </div>
                </div>
              </div>
              <!-- <div class="row margin-t-m">
                <div class="margin-t-m">
                  <div class="template">
                    <span>Reminder For Declaration Email Template</span>
                    <div class="templateData">
                      <button>
                        <img src="@/assets/edit.png" alt />
                      </button>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </template>
      </tl-accordion>
      <tl-accordion class="margin-t-25px" headerName="FBP Claims">
        <template v-slot:accordionBody>
          <div :disabled="!(ifEnableFBP && ifTeamleaderPermission) || ifSuperAdmin">
            <div class="row">
              <div class="col-12 margin-b-s">
                <span class="label">Date range for FBP Claims</span>
              </div>
              <div class="col-3">
                <tl-select
                  label="From *"
                  name="From"
                  :options="Array.from(Array(31).keys(), (val) => val + 1)"
                  v-model="
                    formdata.claim_start_date
                  "
                  @change="(val)=>{getDeclarationClaimDayList(formdata.claim_start_date = val, formdata.claim_end_date); formdata.claim_end_date=null}"
                />
              </div>
              <div class="col-3">
                <tl-select
                  label="To *"
                  name="To"
                  :options="Array.from(Array(31-Number(formdata.claim_start_date)).keys(), val=>Number(formdata.claim_start_date)+val+1)"
                  v-model="formdata.claim_end_date"
                  @change="(val)=>{getDeclarationClaimDayList(formdata.claim_start_date, formdata.claim_end_date = val)}"
                />
              </div>
            </div>
            <div class="row margin-t-l">
              <div class="col-12">
                <span class="label">Reminder Settings</span>
              </div>
              <div class="col-12 margin-t-m">
                <tl-radio
                  label="Periodically"
                  name="claimReminderSettings"
                  v-model="
                    formdata.claim_reminder_option
                  "
                  value="everyday"
                  id="subperiodically"
                  data-vv-as="FBP Reminder Settings"
                  ref="claimReminderSettingsVal"
                />
              </div>
              <div class="col-12 margin-t-15px">
                <tl-radio
                  label="On Specific Dates"
                  name="claimReminderSettings"
                  v-model="
                    formdata.claim_reminder_option
                  "
                  @change="(val) => formdata.claim_reminder_option = val"
                  value="selected_days"
                  id="subspecific"
                  data-vv-as="FBP Reminder Settings"
                  ref="claimReminderSettingsVal"
                />
              </div>
              <div
                class="col-12 margin-t-m"
                v-if="
                  formdata.claim_reminder_option == 'selected_days'
                "
              >
                <ul class="days-box">
                  <li
                    :class="{ selected: day.selected }"
                    v-for="(day, index) in monthDaysClaim"
                    :key="index"
                    :value="day.day"
                    @click="weekOffDaysClaim(index)"
                  >
                    {{ day.day }}
                  </li>
                </ul>
              </div>
              <div
                class="col-12 margin-t-m"
                v-if="
                  formdata.claim_reminder_option != 'selected_days'
                "
              >
                <tl-select
                  label="Start Date *"
                  name="declarationReminderStartDate"
                  labelText="day"
                  v-model="formdata.claim_reminder_date"
                  :options="monthDaysClaim"
                  @change="
                    (val) =>
                      (formdata.claim_reminder_date = val.day)"
                  data-vv-as="start date"
                />
              </div>
            </div>
            <div class="row margin-t-m">
              <div class="col-12">
                <tl-select
                  label="Send Reminder To *"
                  labelText="name"
                  name="Send Reminder"
                  v-model="formdata.claim_reminder_data"
                  :options="reminderToOptions"
                  @change="
                    (val) =>
                      (formdata.claim_reminder_data =
                        val)
                  "
                  data-vv-as="send reminder to"
                />
              </div>
              <div class="col-12">
                <div class="row margin-t-m">
                  <div class="margin-t-m">
                    <span>Send Reminder On : </span>
                  </div>
                  <tl-select
                    class="select"
                    labelText="name"
                    name="hr:"
                    :options="hourOption"
                    v-model="formdata.claim_send_on_hr"
                    @change="
                      (val) =>
                        (formdata.claim_send_on_hr = val)
                    "
                  />
                  <div class="margin-t-m">
                    <span> Hours</span>
                  </div>
                  <tl-select
                    class="select"
                    labelText="name"
                    name="min:"
                    :options="minutesOption"
                    v-model="formdata.claim_send_on_min"
                    @change="
                      (val) =>
                        (formdata.claim_send_on_min = val)
                    "
                  />
                  <div class="margin-t-m">
                    <span>Minutes</span>
                  </div>
                </div>
              </div>
              <!-- <div class="row margin-t-m">
                <div class="margin-t-m">
                  <div class="template">
                    <span>Reminder For FBP claims Email Template</span>
                    <div class="templateData">
                      <button>
                        <img src="@/assets/edit.png" alt />
                      </button>
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="row margin-t-l">
                <div class="col-12">
                  <span class="label">FBP Claims to be paid</span>
                </div>
                <div class="col-12 margin-t-m">
                  <tl-radio
                    label="With payroll"
                    name="withPayroll"
                    v-model="formdata.fbp_claims_to_be_paid"
                    value="With_payroll"
                    id="withPayroll"
                  />
                </div>
                <div class="col-12 margin-t-15px">
                  <tl-radio
                    label="Without payroll"
                    name="withoutPayroll"
                    v-model="formdata.fbp_claims_to_be_paid"
                    value="outside_payroll"
                    id="withoutPayroll"
                  />
                </div>
              </div>
              <div class="row margin-t-m">
                  <div class="col-12">
                      <span class="label">On Settlement of FBP claim</span>
                  </div>
                <div class="margin-t-m">
                    <tl-checkbox
                      class="mb-3"
                      label="Send Email to Approver"
                      @change="
                      (val) => (formdata.sent_approver_email_on_settlement = val)
                      "
                      :checked="formdata.sent_approver_email_on_settlement"
                  ></tl-checkbox>
                  <!-- <div class="template">
                    <span>Reminder For FBP Claims Email Template</span>
                    <div class="templateData">
                      <button>
                        <img src="@/assets/edit.png" alt />
                      </button> 
                    </div>
                  </div> -->
                </div>

                <div class="margin-t-m marginleft-32">
                    <tl-checkbox
                      class="mb-3"
                      label="Send Email to Applier"
                      @change="
                      (val) => (formdata.sent_applier_email_on_settlement = val)
                      "
                      :checked="formdata.sent_applier_email_on_settlement"
                  ></tl-checkbox>
                  <!-- <div class="template">
                    <span>Reminder For FBP Claims Email Template</span>
                    <div class="templateData">
                      <button>
                        <img src="@/assets/edit.png" alt />
                      </button>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>  
        </template>
      </tl-accordion>
      
    </div>
    <!-- <tick-animation v-if="showSuccessMsg"></tick-animation> -->

    <!-- Start UAT_60 -->
    <pop-up-message
      v-if="showWarningPopup"
      message="On skip, your made changes won't be saved!"
      popupType="Warning"
      :popupHeaderMessage="'Warning'"
      :closable="false"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button
            class="btn-popup-secondary"
            type="button"
            @click="cancelEvent()"
          >
            Cancel
          </button>
          <button class="btn-popup" type="button" @click="skip()">Skip</button>
        </div>
      </template>
    </pop-up-message>
    <!-- End UAT_60 -->
    <bottom-action-container class="placeAtEnd">
      <btn-skip @navClicked="skip()"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="previousPage()" />
          <!-- Start PL_2030 -->
          <btn text="Next" type="primary" @click="submitFBPData" />
          <!-- End PL_2030 -->
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import { selectMixin } from "@/mixins/selectMixin";
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  mixins: [selectMixin],
  data() {
    return {
      hourOption: Array.from(Array(23), (x, index) => index + 1),
      minutesOption: Array.from(Array(60), (x, index) => index),
      showSuccessMsg: false,
      showWarningPopup: false, // UAT_60
      responseMsg: "",
      reminderToOptions: [
        { id: "undeclared", name: "Employees whose FBP are not declared" },
        { id: "all_employees", name: "All Employees" },
      ],
      monthDays: [],
      monthDaysClaim: [],
      errmsg: "",
      toast: false,
      fbpSettingsValue: false,
      role: "",
      formdata: {
        id: undefined,
        le_id: undefined,
        declaration_start_date: "",
        declaration_end_date: "",
        declaration_reminder_option: "everyday",
        declaration_reminder_to: "",
        declaration_reminder_data: "",
        declaration_send_reminder: false,
        claim_start_date: "",
        claim_send_reminder: false,
        claim_end_date: "",
        claim_reminder_option: "everyday",
        fbp_claims_to_be_paid: "With_payroll",
        sent_approver_email_on_settlement: false,
        sent_applier_email_on_settlement: false,
        declaration_reminder_dates: [],
        claim_reminder_dates: [],
        claim_reminder_to: "",
        claim_reminder_data: "",
        fbp_criteria: undefined,
        fbpdeclaration_months: [],
        declaration_reminder_date:undefined,
        claim_reminder_date:"",
        claim_send_on_hr:null,
        claim_send_on_min:null,
        declaration_send_on_hr:null,
        declaration_send_on_min:null,
        start_month: null,
        end_month: null,
        lop_deduction_from: null,
        enable_fbpdeclaration_ess: null,
        decalaration_reminder_email_subject: "",
        declaration_reminder_email_text: "",
        claim_reminder_email_subject: "",
        claim_reminder_email_text: "",
        send_email_on_settlement: "true",
        declaration_reminder_time: null,
        claim_reminder_time: null,
        settlement_approver_email_subject: "",
        settlement_approver_email_text: "",
        settlement_applier_email_subject: "",
        settlement_applier_email_text: "",
        run_fbp_with_monthly_payroll: true,
        settlement_email_subject: "",
        opening_claim_window: true,
      }
    };
  },
  computed: {
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
    }),
    
    ...mapGetters("onboard/legal_entities", {
      legalEntity: "record",
      editForm: "editMode"
    }), 

    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },

    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },

    ...mapState("onboard/organization", {
      orgId: (state) => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.fbpSettingsValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if (this.role === "TEAMLEADER" || this.role === "ADMIN") {
      //   if (this.fbpSettingsValue) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
    ifEnableFBP() {
      if (this.legalEntity.enable_fbp) {
        return true
      } else {
        return false
      }
    }
  },

  mounted() {
    this.getOrgLeIdList();
    this.fetchAll();
  },
  methods: {
    ...mapActions("onboard/fbpConfigure", {
      act_create: "create",
      act_fetchAll: "fetchAllcomponents",
      act_update: "updateComponent"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async fetchAll() {
      let res = await this.act_fetchAll(this.leId);
      //console.log("Res------->",res);
      if(res.data.payload.length > 0) {
        this.formdata.id = res.data.payload[0].id;
        //this.formdata.le_id = "01d1f236-afd7-4422-9ee9-ea88587f4b1f";
        this.formdata.le_id = this.leId;
        this.formdata.declaration_start_date = res.data.payload[0].declaration_start_date ? res.data.payload[0].declaration_start_date : 1;
        this.formdata.declaration_end_date = res.data.payload[0].declaration_end_date ? res.data.payload[0].declaration_end_date : 2;
        this.formdata.declaration_reminder_option = res.data.payload[0].declaration_reminder_option;
        this.formdata.declaration_reminder_data =  res.data.payload[0].declaration_reminder_to == "all_employees" ? { id: "all_employees", name: "All Employees"} : { id: "undeclared", name: "Employees whose FBP are not declared"};
        this.formdata.claim_reminder_data =  res.data.payload[0].claim_reminder_to == "all_employees" ? { id: "all_employees", name: "All Employees"} : { id: "undeclared", name: "Employees whose FBP are not declared"};
        this.formdata.declaration_reminder_dates = res.data.payload[0].declaration_reminder_dates;
        this.formdata.declaration_send_reminder = res.data.payload[0].declaration_send_reminder;
        this.formdata.claim_send_reminder = res.data.payload[0].claim_send_reminder;
        
        this.formdata.declaration_reminder_date = res.data.payload[0].declaration_reminder_date;
        this.formdata.claim_reminder_date = res.data.payload[0].claim_reminder_date;
        this.formdata.claim_send_on_hr = res.data.payload[0].claim_send_on_hr;
        this.formdata.claim_send_on_min = res.data.payload[0].claim_send_on_min;
        this.formdata.declaration_send_on_hr = res.data.payload[0].declaration_send_on_hr;
        this.formdata.declaration_send_on_min = res.data.payload[0].declaration_send_on_min;
        this.getDeclarationDayList(this.formdata.declaration_start_date, this.formdata.declaration_end_date);

        this.formdata.claim_start_date = res.data.payload[0].claim_start_date ? res.data.payload[0].claim_start_date : 1;
        this.formdata.claim_end_date = res.data.payload[0].claim_end_date ? res.data.payload[0].claim_end_date : 2;
        this.formdata.claim_reminder_option = res.data.payload[0].claim_reminder_option;
        this.formdata.fbp_claims_to_be_paid = res.data.payload[0].fbp_claims_to_be_paid;
        this.formdata.sent_approver_email_on_settlement = res.data.payload[0].sent_approver_email_on_settlement;
        this.formdata.sent_applier_email_on_settlement = res.data.payload[0].sent_applier_email_on_settlement;
        this.formdata.claim_reminder_dates = res.data.payload[0].claim_reminder_dates;
        this.getDeclarationClaimDayList(this.formdata.claim_start_date, this.formdata.claim_end_date);
        this.formdata.fbp_criteria = res.data.payload[0].fbp_criteria;
        if (res.data.payload[0].fbpdeclaration_months.length > 0) {
          this.formdata.fbpdeclaration_months = res.data.payload[0].fbpdeclaration_months.map(i => Number(i));
        }
      } else {
        this.getDeclarationDayList(1, 2);
        this.getDeclarationClaimDayList(1, 2);
      }
    },

    // Start UAT_60
    cancelEvent() {
      this.showWarningPopup = false;
    },

    skip() {
      this.showWarningPopup = false;
      this.nextPage();
    },
    // End UAT_60

    /* function to validate from */
    async submitFBPData() {
      if (this.ifAnchor || !(this.ifEnableFBP && this.ifTeamleaderPermission) || this.ifSuperAdmin) {
        this.nextPage();
      } else {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.performAction();
          } else {
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .focus();
            this.$el
              .querySelector(
                '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
              )
              .scrollIntoView({
                behavior: "smooth",
                block: "center",
                inline: "center",
              });
          }
        });
      }
    },

    /* server call to submit form data */
    async performAction() {
      try {
        //this.formdata.le_id = this.leId;
        this.errmsg = "";
        this.toast = false;
        let res = null;
        
        if(this.formdata.id) {
          this.formdata.declaration_start_date = String(this.formdata.declaration_start_date);
          this.formdata.declaration_end_date = String(this.formdata.declaration_end_date);
          this.formdata.declaration_reminder_date = String(this.formdata.declaration_reminder_date);
          this.formdata.claim_start_date = String(this.formdata.claim_start_date);
          this.formdata.claim_end_date = String(this.formdata.claim_end_date);
          this.formdata.claim_reminder_date = String(this.formdata.claim_reminder_date);
          this.formdata.declaration_reminder_to = this.formdata.declaration_reminder_data.id;
          this.formdata.claim_reminder_to = this.formdata.claim_reminder_data.id;
          res = await this.act_update({
            id: this.formdata.id,
            data: {
              ...this.formdata,
            },
          });
          this.$root._data.isSaving = true;
        } else {
          this.formdata.declaration_start_date = String(this.formdata.declaration_start_date);
          this.formdata.declaration_end_date = String(this.formdata.declaration_end_date);
          this.formdata.declaration_reminder_date = String(this.formdata.declaration_reminder_date);
          this.formdata.claim_start_date = String(this.formdata.claim_start_date);
          this.formdata.claim_end_date = String(this.formdata.claim_end_date);
          this.formdata.claim_reminder_date = String(this.formdata.claim_reminder_date);
          this.formdata.declaration_reminder_to = this.formdata.declaration_reminder_data.id;
          this.formdata.claim_reminder_to = this.formdata.claim_reminder_data.id;
          this.formdata.le_id = this.leId;
          res = await this.act_create({
            data: {
              ...this.formdata,
            },
          });
          this.$root._data.isSaving = true;
        }
        setTimeout(() => {
          if (res.data.status) {
            this.responseMsg = "FBP Settings " + res.data.message;
            this.showSuccessMsg = true;
            this.hideSuccessMsg();
          }
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to hide success message */
    hideSuccessMsg() {
      setTimeout(() => {
        this.showSuccessMsg = false;
        this.nextPage();
      }, 1000);
    },

    nextPage() {
      this.$router.push(
        `/onboarding/entity/${this.$route.params.entity_index}/ctcSlab`
      );
    },

    previousPage() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/paygroup`
      });
    },

    /* function to get the list of dates after selecting declaration start and end dates  */
    getDeclarationDayList(val1, val2) {
      try {
        if (val1 && val2) {
          this.monthDays = [];
          let count = val1 ? Number(val1) : val1;
          val2 = val2 ? Number(val2) : val2;
          while (count <= val2) {
            this.monthDays.push({
              day: count,
              selected: false,
            });

            count++;
          }
        }
        if (this.formdata.declaration_reminder_dates.length > 0) {
          this.formdata.declaration_reminder_dates = this.formdata.declaration_reminder_dates.map(i => Number(i));
          this.monthDays.map(i => {
            if (this.formdata.declaration_reminder_dates.find(x => x === i.day)) {
              i.selected = true
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    getDeclarationClaimDayList(val1, val2) {
      try {
        if (val1 && val2) {
          this.monthDaysClaim = [];
          let count = val1 ? Number(val1) : val1;
          val2 = val2 ? Number(val2) : val2;
          while (count <= val2) {
            this.monthDaysClaim.push({
              day: count,
              selected: false,
            });

            count++;
          }
        }
        if (this.formdata.claim_reminder_dates.length > 0) {
          this.formdata.claim_reminder_dates = this.formdata.claim_reminder_dates.map(i => Number(i));
          this.monthDaysClaim.map(i => {
            if (this.formdata.claim_reminder_dates.find(x => x === i.day)) {
              i.selected = true
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to select dates(In declaration section) after selecting as 'on specific dates' */
    weekOffDays(idx) {
      try {
        this.monthDays[idx].selected = !this.monthDays[idx].selected;
        const isPresent = this.formdata.declaration_reminder_dates.find(i => i === this.monthDays[idx].day);
        if (!isPresent && this.monthDays[idx].selected) {
          this.formdata.declaration_reminder_dates.push(this.monthDays[idx].day);
          this.formdata.declaration_reminder_dates.sort();
        } else {
          const index = this.formdata.declaration_reminder_dates.findIndex(i => i === this.monthDays[idx].day);
          if (index > -1) {
            this.formdata.declaration_reminder_dates.splice(index, 1);
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to select dates(in submission section) after selecting as 'on specific dates' */
    weekOffDaysClaim(idx) {
      try {
        this.monthDaysClaim[idx].selected = !this.monthDaysClaim[idx].selected;
        const isPresent = this.formdata.claim_reminder_dates.find(i => i === this.monthDaysClaim[idx].day);
        if (!isPresent && this.monthDaysClaim[idx].selected) {
          this.formdata.claim_reminder_dates.push(this.monthDaysClaim[idx].day);
          this.formdata.claim_reminder_dates.sort();
        } else {
          const index = this.formdata.claim_reminder_dates.findIndex(i => i === this.monthDaysClaim[idx].day);
          if (index > -1) {
            this.formdata.claim_reminder_dates.splice(index, 1);
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.leId;
      //console.log("Org:", org);
      //console.log("Le ID", le);
      let bodyParams = {};
      let data = await this.getOrgLeList({
        data: {
          ...bodyParams,
        },
      });
      this.role = data.data.user.userRole;
      this.fbpSettingsValue = data.data.user.permissions
        .fbp_settings
        ? true
        : false;
      //console.log("PL-3406", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.label {
  color: #444444;
  font-size: 14px;
  font-weight: 600;
  font-family: Montserrat;
}
.select {
  width: 80px;
  margin-left: 10px;
  margin-right: 10px;
}
.template {
  width: 259px;
  height: 76px;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(88, 81, 81, 0.16);
  background-color: #f5f5f5;
}
.templateData {
  padding-top: -30px;
  margin: 0px 0px 0px 235px;
}

.belowText {
  margin-left: 3.5%;
}
.bg-grey {
  background-color: #e4e4e4;
  padding: 10px;
}
ul {
  padding-left: 0px;
  margin-left: 24px;
}
.days-box {
  justify-content: space-between;
  border-radius: 4px;
  background: #f9f9f9;
  li {
    list-style: none;
    display: inline-block;
    font-weight: 500;
    width: 50px;
    margin-bottom: 3px;
    padding: 15px 20px;
    cursor: pointer;
    &:hover,
    &.selected {
      background-color: #34c0be;
      color: #ffffff;
    }
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
